
import Nav from "./Nav";
import Footer from "./Footer";
import ExitIntentPopup from "./ExitIntentPopup";
export default function Layout({children}){
  return(
      <>
       <Nav/>
       <main className="main_class">
        <div className="container-fluid">
            {children}
        </div>
       </main>
       <Footer/>
       <ExitIntentPopup />
       </>
  )
}